import logo from '../assets/logo-optimized.png';

const FMLogo = ({ className = '' }) => {
  return (
    <img
      src={logo}
      alt="Fitness Mitra"
      width={128}
      height={80}
      fetchPriority="high"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default FMLogo;
